export const AccordionHeaderParamsTexts = {
  HeaderDefaultTitle: 'Дополнительно',
  HeaderDefaultDescription: 'Заполните данные',
};
